import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

const FutureSectionStyled = styled.section.attrs({
  className: "u-col u-items-center",
})`
  /* スクロールスナップの設定 */
  scroll-snap-align: start;
`;

const FutureSectionTextStyled = styled(motion.section).attrs({
  className: "u-text-center bodytext",
})`
  word-break: normal;

  @media (width > 640px) {
    word-break: keep-all;
  }
`;

const OsFutureSection = () => {
  const isMobile = useSelector((state) => state.device.isMobile);
  
  return (
    <FutureSectionStyled className="u-col-center u-gap16 u-fullpage">
      <div className="bodytext-13 u-text-light-gray">
        SOUND PRODUCTION × DIGITAL
      </div>
        <motion.h2
          className="heading-spacing-2448 slideup"
          initial={{ opacity: 0 }} // 初期状態
          whileInView={{ opacity: 1 }} // スクロールで表示されたときの状態
          transition={{ duration: 1 }} // アニメーションの時間
          viewport={{ once: false, amount: 0 }} // 画面上から90%の位置でアニメーションを始動
        >
          魔法の融合
        </motion.h2>
        <FutureSectionTextStyled
          initial={{ opacity: 0, y: 16 }} // 初期状態
          whileInView={{ opacity: 1, y: 0 }} // スクロールで表示されたときの状態
          transition={{ duration: 1 }} // アニメーションの時間
          viewport={{ once: false, amount: 0.3 }} // 画面上から90%の位置でアニメーションを始動
        >
          {isMobile ? (
            <>
              soremo OSなら、プロダクションワークをパワフルに解消。
              <br />
              ワークフローは着実に。
              <br />
              プライオリティは明快に。
              <br />
              コミュニケーションは円滑に。
              <br />
            </>
          ) : (
            <>
              soremo OSなら、プロダクションワークをパワフルに解消。
              <br />
              ワークフローは着実に。プライオリティは明快に。コミュニケーションは円滑に。
              <br />
            </>
          )}
          コラボレーションにまつわる注意散漫なタスクを減らし、
          <br />
          あなたの専門性と価値ある実作業を支えます。
        </FutureSectionTextStyled>
    </FutureSectionStyled>
  );
};

export default OsFutureSection;
